import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VeeValidate, {Validator} from 'vee-validate'
import es from 'vee-validate/dist/locale/es'
import ApiService from './services/api.service'
import {TokenService} from './services/storage.service'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import CkEditor from '@ckeditor/ckeditor5-vue'
import VueKonva from 'vue-konva'

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'),{
  moment
});
Validator.localize('es', es);
// Set library Vue fontawesome
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
// Set the base URL of the API
ApiService.init(process.env.VUE_APP_API_URL);
Vue.use(CkEditor);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(VueKonva);
Vue.use(VeeValidate, {
  locale:'es',
  fieldsBagName: 'veeFields'
});
Vue.config.productionTip = false

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader();
  ApiService.mount401Interceptor();
}

new Vue({
  router,
  store,
  methods: {
    setUrlFile(file) {
      return `${process.env.VUE_APP_API_CDN}/${file}`;
    },
    triggetSuccessMgs(title, text) {
      this.$swal({
        type: "success",
        title: title,
        text: text,
        showConfirmButton: false,
        timer: 3500,
        toast: true,
        position: "top",
        customClass: "succ-swal"
      });
    },
    triggerWarnMgs(title, text) {
      this.$swal({
        type: "warning",
        title: title,
        text: text,
        showConfirmButton: false,
        timer: 3500,
        toast: true,
        position: "top",
        customClass: "warn-swal"
      });
    },
    triggerErrorMgs(title, text) {
      this.$swal({
        type: "error",
        title: title,
        text: text,
        showConfirmButton: false,
        timer: 1800,
        toast: true,
        position: "top",
        customClass: "err-swal"
      });
    }
  },
  render: h => h(App)
}).$mount('#app')
